import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { I18nextProvider } from 'react-i18next';
import en from '../en.json'; 
import fq from '../fq.json';

const resources = {
  en: {
    translation: en
  },
  fq: {
    translation: fq
  }
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Set the default language
    fallbackLng: 'en', // Fallback language if preferred language couldn't be loaded
    keySeparator:false,
    interpolation: {
      escapeValue: false, // Prevents automatic escaping of strings
    }
  });
export default i18n;